import styled, { css } from "styled-components";
import { listItemStylesEnhancer } from "../listStylesEnhancer";
var ListItemContentWrapper = styled.div.withConfig({
  displayName: "ListItemstyle__ListItemContentWrapper",
  componentId: "sc-1nmmsvx-0"
})([""]);
var LiStyled = styled.li.withConfig({
  displayName: "ListItemstyle__LiStyled",
  componentId: "sc-1nmmsvx-1"
})(function (_ref) {
  var theme = _ref.theme;
  var tokens = theme.componentsTokens.list;
  return css(["display:flex;&:last-child{padding-bottom:0;}& > ", " > ol,& > ", " > ul{padding-bottom:0;", "}", ";"], ListItemContentWrapper, ListItemContentWrapper, tokens.nestedListPt && css(["padding-top:", ";"], tokens.nestedListPt), listItemStylesEnhancer);
});
export { ListItemContentWrapper, LiStyled };